'use strict';

// Vue
import Vue from 'vue';

// State
const state = {};

// Getters
const getters = {
  activeSection: state => state.activeSection,
  defaultOffset: state => state.defaultOffset || 0,
};

// Mutations
const mutations = {
  SAVE_ACTIVE_SECTION_TO_STATE (state, section) {
    Vue.set(state, 'activeSection', section);
  },

  SAVE_DEFAULT_OFFSET (state, payload) {
    Vue.set(state, 'defaultOffset', payload);
  },
};

// Actions
const actions = {
  saveActiveSection({ commit }, section) {
    if ( section ) {
      commit('SAVE_ACTIVE_SECTION_TO_STATE', section);
    }
  },

  saveDefaultOffset({ commit }, payload) {
    if ( payload ) {
      commit('SAVE_DEFAULT_OFFSET', payload);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./client/store/sidebar.js